import { Document, StyleSheet, View } from '@react-pdf/renderer';

import { Page } from '../../../components/PdfExportV2/Page/Page.tsx';
import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';
import { METHODOLOGY_TEXT } from '../consts.ts';
import { getCommentarySectionText } from '../utils.ts';
import { ExportCommentarySection } from './ExportCommentarySection.tsx';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
});

export const ExportMethodology = ({ subjectAddress }: { subjectAddress: string }) => (
  <Document>
    <Page title="">
      <ExportCommentarySection
        subjectAddress={subjectAddress}
        {...getCommentarySectionText('methodology')}
      >
        <View style={styles.container}>
          {METHODOLOGY_TEXT.map((text, index) => (
            <Text key={index} variant="body1">
              {text}
            </Text>
          ))}
        </View>
      </ExportCommentarySection>
    </Page>
  </Document>
);
